import start from './start';
import rocks from './rocks';

export default {
  start,
  rocks
}
